import * as React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon';
import { SvgIconProps as DefaultSvgIconProps } from '@material-ui/core/SvgIcon';
import { useTheme } from '@material-ui/core/styles';

export const SendIcon = (props: DefaultSvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon {...props} viewBox="0 0 74.185 37.606">
      <g transform="translate(0 -85.26)">
        <path
          d="M110.855,122.835c.028-.006.055-.013.083-.02s.047-.011.07-.018.053-.018.079-.028.047-.016.07-.026.048-.022.073-.034.047-.021.07-.034.045-.026.067-.039.046-.027.068-.042.046-.033.069-.051.039-.028.058-.043c.035-.029.068-.059.1-.09l.018-.016.017-.019c.031-.032.061-.064.089-.1s.031-.041.046-.062.033-.042.047-.065.03-.048.044-.073.025-.041.037-.062.024-.05.036-.075.022-.044.031-.067.018-.05.027-.075.018-.049.026-.074.013-.051.02-.077.014-.05.018-.076.01-.061.014-.091.007-.043.009-.064a1.6,1.6,0,0,0,.008-.16V86.869a1.609,1.609,0,0,0-1.609-1.609H59.863l-.042,0c-.031,0-.061,0-.092,0l-.072.008-.082.012L59.5,85.3l-.076.02-.074.023-.075.027L59.2,85.4l-.075.036-.063.034-.074.045-.059.04c-.023.016-.045.033-.067.05l-.059.05c-.019.017-.038.034-.057.052s-.042.042-.062.063-.021.02-.03.031l-.016.02c-.02.023-.039.048-.058.073s-.028.036-.041.054-.032.049-.048.074-.026.041-.037.061-.025.049-.038.073-.023.045-.033.068-.02.049-.029.074-.019.048-.027.073-.014.05-.021.075-.014.051-.02.077-.009.049-.013.073-.009.056-.013.084,0,.047-.006.07,0,.06,0,.09c0,.009,0,.017,0,.026V96.79a1.609,1.609,0,1,0,3.218,0V90.441l14.3,12.664a1.626,1.626,0,0,0-.213.177l-14.09,14.09V106.8a1.609,1.609,0,1,0-3.218,0v1.966H49.942a1.609,1.609,0,0,0,0,3.218h8.312v9.273a1.609,1.609,0,0,0,1.609,1.609h50.678c.053,0,.106,0,.159-.008.025,0,.048-.007.073-.011S110.827,122.841,110.855,122.835Zm-1.923-5.462-14.091-14.09-.028-.025,10.593-8.987a1.609,1.609,0,1,0-2.082-2.453l-18.1,15.357-21.117-18.7h44.825v28.9ZM77.838,105.559a1.6,1.6,0,0,0,.281-.379l6.017,5.327a1.609,1.609,0,0,0,2.108.022l6.132-5.2a1.616,1.616,0,0,0,.191.232l14.09,14.09H63.747Z"
          transform="translate(-37.965 0)"
          fill={props.color || theme.palette.text.primary}
        />
        <path
          d="M1.609,158.894H28.78a1.609,1.609,0,1,0,0-3.218H1.609a1.609,1.609,0,1,0,0,3.218Z"
          transform="translate(0 -55.311)"
          fill={props.color || theme.palette.text.primary}
        />
        <path
          d="M14.734,117.563h12.2a1.609,1.609,0,1,0,0-3.218h-12.2a1.609,1.609,0,1,0,0,3.218Z"
          transform="translate(-10.31 -22.846)"
          fill={props.color || theme.palette.text.primary}
        />
        <path
          d="M13.407,226.51H1.609a1.609,1.609,0,1,0,0,3.218h11.8a1.609,1.609,0,1,0,0-3.218Z"
          transform="translate(0 -110.951)"
          fill={props.color || theme.palette.text.primary}
        />
      </g>
    </SvgIcon>
  );
};
